import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initVersionChecker } from "@/lib/versionCheck";

// Start version detection (SW + hashed-bundle comparison)
initVersionChecker();

const root = ReactDOM.createRoot(document.getElementById("root"));
const app = <App />;
root.render(
  process.env.NODE_ENV === "development" ? <React.StrictMode>{app}</React.StrictMode> : app,
);
